// extracted by mini-css-extract-plugin
module.exports = {"switch":"GeneralProperties_switch__SCeSb"};